import React from "react";
import ProgramCard from "./ProgramCard";

const ProgramsGrid = ({ programs, enrolledProgramId, onEnroll }) => {
  const filteredPrograms = enrolledProgramId
    ? programs.filter((program) => program.id !== enrolledProgramId)
    : programs;

  return (
    <div className="programs-grid">
      {filteredPrograms.map((program) => (
        <ProgramCard key={program.id} program={program} onEnroll={onEnroll} />
      ))}
    </div>
  );
};

export default ProgramsGrid;
